import type { IChipData, IUserChipData, TUserReward } from '../_header'
import { CHIP_KEY, _chips } from '../config'
import { create } from 'zustand'

type TGpsPosition = { lat: number; lng: number }

type TUserChipsObject = Record<
  CHIP_KEY,
  {
    order: number
    collected: boolean
  }
>

const initialUserChipsObject: TUserChipsObject = Object.fromEntries(
  Object.values(CHIP_KEY).map((key, index) => [
    key,
    { order: index + 1, collected: false },
  ]),
) as TUserChipsObject

export interface IRpgStore {
  tempChipId: CHIP_KEY | undefined
  setTempChipId: React.Dispatch<React.SetStateAction<CHIP_KEY | undefined>>
  userChips: IUserChipData[]
  setUserChips: React.Dispatch<React.SetStateAction<IUserChipData[]>>
  userChipsObject: TUserChipsObject
  setUserChipObject: React.Dispatch<React.SetStateAction<TUserChipsObject>>
  userGpsPosition: TGpsPosition
  setUserGpsPosition: (position: TGpsPosition) => void
  isRedeemed: boolean
  setIsRedeemed: (value: boolean) => void
  userReward: TUserReward | 'NULL'
  setUserReward: (value: TUserReward | 'NULL') => void
  isCameraOpen: boolean
  setIsCameraOpen: React.Dispatch<React.SetStateAction<boolean>>
  disableCamera: boolean
  setDisableCamera: (value: boolean) => void
  chipInfoDrawer: IChipData
  setChipInfoDrawer: (chipKey: CHIP_KEY) => void
  openChipInfoDrawer: boolean
  setOpenChipInfoDrawer: React.Dispatch<React.SetStateAction<boolean>>
}

export const useRpgStore = create<IRpgStore>((set) => ({
  tempChipId: undefined,
  setTempChipId: (value) =>
    set(({ tempChipId: prevTempChipId }) => ({
      tempChipId: typeof value === 'function' ? value(prevTempChipId) : value,
    })),
  userChips: [],
  setUserChips: (value) =>
    set(({ userChips: prevUserChips }) => ({
      userChips: typeof value === 'function' ? value(prevUserChips) : value,
    })),
  userChipsObject: initialUserChipsObject,
  setUserChipObject: (value) =>
    set(({ userChipsObject: prev }) => ({
      userChipsObject: typeof value === 'function' ? value(prev) : value,
    })),
  userGpsPosition: { lat: 0, lng: 0 },
  setUserGpsPosition: (position) => set({ userGpsPosition: position }),
  isRedeemed: false,
  setIsRedeemed: (value) => set({ isRedeemed: value }),
  userReward: 'NULL',
  setUserReward: (value) => set({ userReward: value }),
  isCameraOpen: false,
  setIsCameraOpen: (value) =>
    set(({ isCameraOpen: prev }) => ({
      isCameraOpen: typeof value === 'function' ? value(prev) : value,
    })),
  disableCamera: false,
  setDisableCamera: (value) => set({ disableCamera: value }),
  chipInfoDrawer: _chips[CHIP_KEY.ID_01],
  setChipInfoDrawer: (chipKey) =>
    set({ chipInfoDrawer: _chips[chipKey], openChipInfoDrawer: true }),
  openChipInfoDrawer: false,
  setOpenChipInfoDrawer: (value) =>
    set(({ openChipInfoDrawer: prevValue }) => ({
      openChipInfoDrawer:
        typeof value === 'function' ? value(prevValue) : value,
    })),
}))
